import { cookiesKeyNames } from '@revbox/common-fe'
import React, { memo, useCallback } from 'react'
import { NavLink } from 'react-router-dom'
import { useJoyride } from '../../contexts/JoyrideContext'
import { addPubParamToUrl } from '../../helpers/add-pub-param-to-url'

const PopulateMenu = ({ menuItems, advertiserId, language, onUpdateSize, isApplicationsAvailable = false, reviewsRecords = 0 }) => {
    const { handleChangePage } = useJoyride()

    const currentUrlParams = new URLSearchParams(window.location.search)
    const pubValue = currentUrlParams.get('pub')
    const filteredMenu =isApplicationsAvailable ? menuItems : menuItems.filter(item => item.label.EN !== 'Applications')

    const toggleSubMenu = useCallback(() => {
        return e => {
            e.preventDefault()

            let parent = e.target.closest('.nav-item')
            let node = parent.parentNode.firstChild

            while (node) {
                if (node !== parent && node.nodeType === Node.ELEMENT_NODE) node.classList.remove('show')
                node = node.nextElementSibling || node.nextSibling
            }

            parent.classList.toggle('show')

            onUpdateSize()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ul className="nav nav-sidebar">
            {filteredMenu.map((item, index) => {
                const hasSubmenu = Array.isArray(item.submenu)
                const isExternal = item.link.startsWith('https://')

                const submenuLinks = hasSubmenu
                    ? item.submenu.map((subItem, subIndex) => (
                          <NavLink key={subIndex} to={addPubParamToUrl(subItem.link, pubValue, advertiserId)} className="nav-sub-link">
                              {subItem.label[language]}
                          </NavLink>
                      ))
                    : null

                const isCampaignMatch =
                    item.link.includes('campaignId') &&
                    (() => {
                        const campaignId = currentUrlParams.get('campaignId')
                        const [path, query] = item.link.split('?')
                        const linkCampaignId = query?.split('=')[1].split('&')[0]
                        return campaignId === linkCampaignId && window.location.pathname === path
                    })()

                const linkTo = addPubParamToUrl(item.link, pubValue, advertiserId)
                const icon = <i className={item.icon}></i>
                const isReviewBudge = reviewsRecords > 0
                const reviewBudgeCount = reviewsRecords > 9 ? '9+' : reviewsRecords === 0 ? '' : reviewsRecords
                const label = <div className="nav-link-label">{item.label[language]}</div>

                const handleTour = () => {
                    if (item.link.includes('adv/campaign/ppc')) {
                        handleChangePage(cookiesKeyNames.tourAdvInit)
                    }
                }

                const renderLink = className => {
                    const itemWithSubmenu = (
                        <div onClick={toggleSubMenu} className={`${className} has-sub`}>
                            {icon} {label}
                        </div>
                    )

                    const externalLink = (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className={className}>
                            {icon} {label}
                            {item.label.EN === 'Queue' && isReviewBudge && <small className="ms-2">{reviewBudgeCount}</small>}
                        </a>
                    )

                    const navLink = (
                        <NavLink to={linkTo} className={className}>
                            {icon} {label}
                            {item.label.EN === 'Queue' && isReviewBudge && <small className="ms-2">{reviewBudgeCount}</small>}
                        </NavLink>
                    )

                    return hasSubmenu ? itemWithSubmenu : isExternal ? externalLink : navLink
                }
                const navClass = isCampaignMatch ? 'nav-link active' : item.link.includes('campaignId') ? 'nav-non-active-link' : 'nav-link'

                const navItem = (
                    <li key={index} className="nav-item">
                        {renderLink(navClass)}
                        {hasSubmenu && <nav className="nav nav-sub">{submenuLinks}</nav>}
                    </li>
                )

                if (item.id) {
                    return (
                        <li key={index} className="nav-item" id={item.id} onClick={handleTour}>
                            {renderLink(navClass)}
                            {hasSubmenu && <nav className="nav nav-sub">{submenuLinks}</nav>}
                        </li>
                    )
                }

                return navItem
            })}
        </ul>
    )
}

export default memo(PopulateMenu)
